import dataFormat from '@home/utils/dbDataFormat/dataFormat';

/**
 * 使用项目统一的 dataFormat 格式化阈值数字，默认 bmk 规则：
 * - < 1000：整数展示（如 999）
 * - >= 1000：BMK + 1位小数（如 10K、1M、1B）
 */
export function formatLimitCount(count: number, formatRule: string = 'bmk'): string {
  return String(dataFormat({ value: count, formatRule }));
}
